import { RouteComponentProps } from "react-router";

//	P R O P S

export interface props___SbDashboardPage extends RouteComponentProps<{ id: string; }> {

}

//	S T A T E

export interface state___SbDashboardPage {

	digitalmenu___collection: any[],
	digitalmenu___collection___isLoading: boolean,

}

//	S T A T E   D E F A U L T

export const state___SbDashboardPage___default: state___SbDashboardPage = {

	digitalmenu___collection: [],
	digitalmenu___collection___isLoading: true,

}